import { slideToggle } from './js-helpers.js';

const scrollWrapper = document.getElementById('site-wrapper-inner--scroll');
const main = document.getElementById('site-main');
const specs = document.getElementById('product-specs');
const trigger = document.querySelector('button[data-accordion="product-specs"]');

let flag = false;
let lastScroll = 0;

const onScroll = async () => {
	if (flag) return;
	flag = true;

	let target = window.innerWidth > 840 ? scrollWrapper : main;

	const height = target.scrollHeight;
	const top = target.scrollTop;
	const bottom = top + target.clientHeight;

	if (bottom >= height && specs.hidden) {
		trigger.classList.add('active');

		await slideToggle(specs);
	}

	if (top < lastScroll) {
		if (bottom < height - 200 && !specs.hidden) {
			trigger.classList.remove('active');

			await slideToggle(specs);
		}
	}

	flag = false;
	lastScroll = top;
};

scrollWrapper.addEventListener('scroll', onScroll, { passive: true });
main.addEventListener('scroll', onScroll, { passive: true });

trigger.addEventListener('click', () => {
	scrollWrapper.removeEventListener('scroll', onScroll);
	main.removeEventListener('scroll', onScroll);
});
